import Avatar from 'react-avatar'
import { getRandomDarkThemeColor } from 'Utils/helperFunctions'

const TableLogHistory = () => {
  const { primary, secondary } = getRandomDarkThemeColor()
  return (
        <>
        <p>Check all transactions.</p>
        <div className="table-responsive">
        <table className="table align-middle">
            <thead>
                <th scope="col">User</th>
                <th scope="col">Date added</th>
                <th scope="col">Task</th>
                <th scope="col">Hours</th>
                <th scope="col">Amount</th>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <Avatar
                            name={'juan Florez'}
                            className='avatarImage me-2'
                            color={primary}
                            fgColor={secondary}
                            round={true}
                            size="38px"
                            textSizeRatio={3}
                        />Juan David Florez</td>
                    <td>Feb 14, 2024</td>
                    <td>TASK1</td>
                    <td>+2</td>
                    <td><span className="text-primary">+$100.000</span></td>
                </tr>
                <tr>
                    <td><Avatar
                            name={'juan Florez'}
                            className='avatarImage me-2'
                            color={primary}
                            fgColor={secondary}
                            round={true}
                            size="38px"
                            textSizeRatio={3}
                        />Sergio Rodriguez</td>
                    <td>Feb 14, 2024</td>
                    <td>Task2</td>
                    <td>-23</td>
                    <td><span className="text-danger">-$100.000</span></td>
                </tr>
            </tbody>
        </table>
        </div>
        </>
  )
}
export default TableLogHistory
